<template>
    <div class="shop-wrapper">
        <div id="orders-list" class="section">
            <!-- Container -->
            <div class="container">

                <!-- Orders List -->
                <div class="columns account-header category-header">
                    <div class="column main-column is-tablet-landscape-padded">
                        <div class="account-title">
                            <h2>Productos</h2>
                            <img :src="require('../../assets/images/icon-bambi.png')" alt="brand-filigrane" class="brand-filigrane">
                        </div>
                        
                        <!-- Controls -->
                         <div class="listing-controls"> 
                        </div>
                        <!-- /Controls -->

                        <!-- Product List -->
                        <div class="columns is-product-list is-multiline">
                            <div class="column is-12">
                                <div class="order-long-card">

                                    <div class="table-container">
                                        <table class="table is-narrow is-fullwidth disclaimer">
                                            <tr>
                                                <td class="is-uppercase has-text-weight-medium has-text-centered">
                                                    Precios Sujetos a variación
                                                </td>
                                            </tr>
                                        </table>

                                        <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth products">
                                            <thead>
                                                <tr>
                                                    <th class="is-uppercase has-text-weight-medium has-text-centered">
                                                        Coef.
                                                    </th>
                                                    <th class="is-uppercase has-text-weight-medium has-text-centered">
                                                        Modelo
                                                    </th>
                                                    <th class="is-uppercase has-text-weight-medium has-text-centered">
                                                        EAN
                                                    </th>
                                                    <th class="is-uppercase has-text-weight-medium has-text-centered">
                                                        Vol.
                                                    </th>
                                                    <th class="is-uppercase has-text-weight-medium has-text-centered description">
                                                        Descripción
                                                    </th>
                                                    <th class="is-uppercase has-text-weight-medium has-text-centered">
                                                        Medidas
                                                    </th>
                                                    <th class="is-uppercase has-text-weight-medium has-text-centered">
                                                        Precio
                                                    </th>
                                                    <th class="is-uppercase has-text-weight-medium has-text-centered">
                                                        Acción
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="( product, index ) in products" 
                                                    v-bind:key="`product-${index}`">
                                                    
                                                    <td class="has-text-centered has-text-weight-bold coeficiente">
                                                        {{ product.Coef }}
                                                    </td>
                                                    <td class="has-text-centered">
                                                        {{ product.Modelo }}
                                                    </td>
                                                    <td class="has-text-centered">
                                                        {{ product.EAN }}
                                                    </td>
                                                    <td class="has-text-centered">
                                                        {{ product.Volumen }}
                                                    </td>
                                                    <td class="description">
                                                        {{ product.Detalle1  }}
                                                        {{ product.Detalle2 }}
                                                    </td>
                                                    <td class="has-text-centered">
                                                        {{ product.Medida }}
                                                    </td>
                                                    <td class="has-text-centered">
                                                        $ {{ product.Precio | MoneyFormat }}
                                                    </td>
                                                    <td class="has-text-centered">
                                                        <span class="add" @click="addItem(product.Codigo)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart has-simple-popover" data-content="Add to Cart" data-placement="top"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>                                        
                                    </div>
                                </div>
                                <span class="content is-small">* Salvo Error U Omisión. Ante inconsistencias consultar al siguiente correo: <a href="mailto:facturacion@bambi.com.ar">facturacion@bambi.com.ar</a></span>
                            </div>
                        </div>
                        <!-- Products list -->

                    <!-- </div> -->
                <!-- </div> -->

                    </div>
                </div>
                <!-- /Orders List -->
            </div>
            <!-- /Container -->
        </div>   
    </div>   
</template>

<script>
import { mapGetters, mapActions } from 'vuex' 

export default {
    name: 'orderIntentions',
    beforeCreate(){
        this.$store.dispatch('products/getProducts')
    },    
    data() {
        return {
            estados: null
        }
    },
    computed: {
        ...mapGetters({
            products: 'products/products',
            errors: 'auth/errors',
        }),
    },
    methods: {
        ...mapActions({
            addToCart: 'cart/addToCart',
        }),
        addItem(producto) {            
            this.addToCart({'modelo': producto});
        },
    }
}
</script>

<style>
.table-container{
    width: 100%;
    padding: 30px;
}
.table-wrapper{
    overflow-x: auto;
}
.products td, .products th,
.disclaimer td, .disclaimer th {
    vertical-align: middle;
    text-align: center;
    font-size: 0.80em;
    transition: all 0.3s;
    font-weight: normal;
}

.products tr:hover td {
    font-weight: bolder;
}

.products.is-narrow td {
    padding: 0.5em 0.75em;
}
.products.is-narrow th {
    padding: 0.75em 0.5em;
    background-color: #d2e5f1;
    color: #1d5375;
}
.disclaimer.is-narrow td {
    border: none;
    border-radius: 3px;
    padding: 0.45em 0.5em;
    background-color: #f0efd7;
    color: #756c1d;
}
.coeficiente{
    background-color: #a4d889;
    color: #1f8219;
    font-size: 1em;
}

.description{
    width: 40% !important;
}
.products td .add{
    color: #999;
    transition: all 0.3s;
    cursor: pointer;
}
.products td .add:hover{
    color: #0023ff;
}
   

</style>